module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "eeepSmall.d57a242c.webp";